import { isNil } from '../../utils';

import { MobizLocalization } from './mobiz-localization.do';
import { SerializableObject } from './serializable-object';
import { SerializableObjectList } from './serializable-object-list.model';

/** The Client Plugin Info domain object. */
export class MobizClientPluginInfo extends SerializableObject {
  extensionKey: string;
  key: string;
  name: string;
  bootstrapFile: string;
  localizations: MobizLocalization[];

  protected coercePropertyType(property: string, value: any) {
    let returnValue = null;
    if (isNil(value)) {
      return returnValue;
    }

    switch (property) {
      case 'localizations':
        let localizationsObject = new SerializableObjectList<MobizLocalization>(MobizLocalization, value);
        returnValue = localizationsObject.items;
        break;

      default:
        returnValue = value;
    }

    return returnValue;
  }

}
